import { VISA, MASTERCARD, AMEX } from '../../constants/cardTypes';

/**
 * Returns the appropiate credit type based on the provided number, or an empty
 * string nothing is found.
 *
 * @param cardNumber - The current card number
 */
export default function creditCardTypeForNumber(cardNumber: string): string {
  if (cardNumber.startsWith('4')) {
    return VISA;
  }
  if (cardNumber.startsWith('5') || cardNumber.startsWith('2')) {
    return MASTERCARD;
  }
  if (cardNumber.startsWith('34') || cardNumber.startsWith('37')) {
    return AMEX;
  }
  return '';
}
